import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={18}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.6232 0.941792C11.2734 0.349869 10.6814 0 9.98194 0C9.28249 0 8.69052 0.349831 8.3407 0.941792L0.242107 15.1749C-0.0807024 15.7668 -0.0807024 16.4663 0.242107 17.0582C0.591938 17.6501 1.1839 18 1.88335 18H18.0805C18.7532 18 19.372 17.6502 19.7218 17.0582C20.0716 16.4662 20.0716 15.7668 19.7218 15.1749L11.6232 0.941792ZM18.3227 16.2511C18.2958 16.305 18.2151 16.3857 18.0806 16.3857H1.88339C1.74883 16.3857 1.66812 16.305 1.64129 16.2511C1.61445 16.1972 1.56058 16.0897 1.64129 15.982L9.73987 1.72198C9.79374 1.61444 9.9283 1.58741 9.98198 1.58741C10.0358 1.58741 10.1434 1.61425 10.2241 1.72198L18.3227 15.982C18.3764 16.0895 18.3495 16.197 18.3227 16.2509V16.2511Z"
      fill="#666666"
    />
    <path
      d="M10.0885 6C9.63109 6 9.28125 6.34983 9.28125 6.80722V10.5739C9.28125 11.0313 9.63108 11.3811 10.0885 11.3811C10.5459 11.3811 10.8957 11.0313 10.8957 10.5739V6.80722C10.8957 6.37668 10.546 6 10.0885 6Z"
      fill="#666666"
    />
    <path
      d="M10.0885 12.1875C9.63109 12.1875 9.28125 12.5373 9.28125 12.9947V13.8019C9.28125 14.2593 9.63108 14.6091 10.0885 14.6091C10.5459 14.6091 10.8957 14.2593 10.8957 13.8019V12.9947C10.8957 12.5642 10.546 12.1875 10.0885 12.1875Z"
      fill="#666666"
    />
  </svg>
);
export default SVGComponent;
